import BarChart from "@app/analytics/MeetingPolicy/BarChart/BarChart";
import getColorFromScore from "@app/analytics/MeetingPolicy/getColorFromScore";
import MeetingPolicyModule from "@app/analytics/MeetingPolicy/MeetingPolicyModule";
import { getBarSeries } from "@app/analytics/MeetingPolicy/meetingPolicyUtils";
import { WeekDay } from "@app/analytics/MeetingPolicy/types";
import useMeetingPolicy from "@app/analytics/MeetingPolicy/useMeetingPolicy";
import useMeetingPolicyQuery from "@app/analytics/MeetingPolicy/useMeetingPolicyQuery";
import { getMetricMetaById } from "@app/analytics/meetops/metrics";
import { titleize } from "@app/utils/utils";

const SORTED_DAYS_OF_WEEK = ["mon", "tue", "wed", "thu", "fri"] as WeekDay[];

const DayOfWeekModule = () => {
  const { toggleState, selectedMetric } = useMeetingPolicy();
  const { highest, lowest, meetingCountSeries, metricSeries, readSeries } =
    useMeetingPolicyQuery({ dimension: "dayOfWeek" });

  const metricMeta = getMetricMetaById(selectedMetric);

  const barMetricsSeries = getBarSeries(
    "vertical",
    "bar",
    SORTED_DAYS_OF_WEEK,
    metricSeries ?? [],
    {
      fillColor: (d) => getColorFromScore(d ?? 0),
      name: metricMeta?.displayName ?? "",
      hideLabels: !toggleState.chartLabels,
      formatDimension: titleize,
    }
  );
  const textMetricSeries = toggleState.meetingCount
    ? [
        getBarSeries(
          "vertical",
          "text",
          SORTED_DAYS_OF_WEEK,
          meetingCountSeries ?? [],
          { name: "Meetings", formatString: (s) => (s ? `[${s}]` : null) }
        ),
      ]
    : [];

  const readMetricSeries = toggleState.readAverage
    ? [
        getBarSeries(
          "vertical",
          "line",
          SORTED_DAYS_OF_WEEK,
          readSeries ?? [],
          { name: "Read Avg", formatDimension: titleize }
        ),
      ]
    : [];

  return (
    <MeetingPolicyModule
      title="Day of Week"
      highest={titleize(highest) ?? "-"}
      lowest={titleize(lowest) ?? "-"}
    >
      <BarChart
        series={[barMetricsSeries, ...textMetricSeries, ...readMetricSeries]}
        orientation="vertical"
        layout={{
          yAxis: {
            label: metricMeta.displayName,
            numTicks: 6,
          },
        }}
      />
    </MeetingPolicyModule>
  );
};

export default DayOfWeekModule;
